import { ReactNode, useContext } from "react";
import { useLocation } from "react-router-dom";

import styles from "./mobileScrollContainer.module.scss";
import { StateContext } from "../../../context/globalContext/context";
import { iGlobalContext } from "../../../context/globalContext/interface";
import { shouldShowBottomNav } from "../bottomNavBar/shouldShowBottomNav";

interface MobileScrollContainerProps {
  children: ReactNode;
}

export default function MobileScrollContainer({ children }: MobileScrollContainerProps): JSX.Element {
  const { pathname } = useLocation();
  const { isMobile, isBottomDrawerOpen, isBookingSearchForm }: iGlobalContext =
    useContext(StateContext);

  const showBottomNav = shouldShowBottomNav({
    pathname,
    isMobile,
    isBottomDrawerOpen,
    isBookingSearchForm,
  });

  return (
    <div data-testid="mobile-scroll-container" className={showBottomNav ? styles.withBottomNav : styles.plain}>
      {children}
    </div>
  );
}
